import isEduFromBpos from "owa-bpos-utils/lib/isEdu";
import type { MailboxInfo } from "owa-client-types";

/**
 * Returns true if the mailbox corresponds to an EDU user.
 * @param mailboxInfo
 */
export function isEduConsolidated(mailboxInfo: MailboxInfo): boolean {
    return isEduFromBpos(mailboxInfo);
}
